"use client";
import {
  useRef,
  useState,
  useEffect,
  KeyboardEvent,
  FormEvent,
  Ref,
} from "react";
import {
  Button,
  Container,
  Checkbox,
  OutsideClickHandler,
  Typography,
} from "src/components/ct-design";
import {
  LOGIN_BANNER_URL,
  MOBILE_COUNTRY_CODES,
  OTP_ERRORS,
  errorConfig,
  loginHelpText,
} from "constants/home";
import "./index.scss";
import { usePathname } from "next/navigation";
import ModalHeader from "./ModalHeader";
import InfoIcon from "icons/info.svg";
import DownChevronOld from "icons/downChevron.svg";
import UpChevron from "icons/upChevron.svg";
import useFetch from "src/network/useFetch";
import { REQUEST_METHODS, HOME_API_ENDPOINTS } from "constants/network";
import ArrowLeft from "icons/arrowLeft.svg";
import { getApiDomain } from "src/utils/apiHelpers";
import Clevertap from "src/analytics/index";
import { ACTION_NAMES, ACTION_ERRORS } from "src/analytics/useAnalytics";
import {
  IGetOTPResponse,
  KeyEvent,
  OTPErrorMessage,
  VerifyOTPAction,
} from "./type";
import BannerSlider from "../BannerSlider";
import OtpBox from "../OtpBox";
import {
  useModalDispatch,
  useGlobalState,
} from "src/context/globalStateContext/provider";
import { getPagePath, validateMobileNumber } from "src/utils/generalUtils";

const otpEndpoint = HOME_API_ENDPOINTS.HOME_GET_OTP;
const verificationEndpoint = HOME_API_ENDPOINTS.VERIFY_OTP;
const LoginWithMobile = () => {
  const [mobile, setMobile] = useState("");
  const eventName = "BUS_UI_Action";

  const { abData } = useGlobalState() || {};
  const { abLogin = "a" } = abData || {};
  const dispatch = useModalDispatch();
  const [isMobileValid, setMobileValid] = useState(true);
  const [otpDigits, setOtpDigits] = useState(["", "", "", ""]);
  const otpString = otpDigits.join("");
  const [apiError, setApiError] = useState("");
  const [showOTP, setShowOTP] = useState(false);
  const refs = [
    useRef<HTMLInputElement>(),
    useRef<HTMLInputElement>(),
    useRef<HTMLInputElement>(),
    useRef<HTMLInputElement>(),
  ];
  const [otpValidationError, setOtpValidationError] = useState("");
  const [retriesLeft, setRetriesLeft] = useState(4);
  const [countDown, setCountDown] = useState(30);
  const [rememberCheckedStatus, setRememberCheckedStatus] = useState(true);
  const [showCodeDropdown, setShowDropdown] = useState(false);
  const [countryCodeIndex, setCountryCodeIndex] = useState(0);
  const countryCode = "+" + MOBILE_COUNTRY_CODES[countryCodeIndex].code;
  const intervalRef = useRef<NodeJS.Timeout>();
  const { fetchData: sendOtpForSignIn, isLoading: OTPloading } =
    useFetch<IGetOTPResponse>(otpEndpoint, {
      method: REQUEST_METHODS.POST,
      init: false,

      onSuccess() {
        setShowOTP(true);
        clearOtp();
        countDownHandler(30);
      },
      onError(error) {
        const { errorResponse } =
          (error as { errorResponse: { message: OTPErrorMessage } }) || {};
        const { message } = errorResponse || {};
        const errRes = Object.hasOwn(errorConfig, message)
          ? errorConfig[message]
          : errorConfig.DEFAULT;
        setApiError(errRes);
        const payload = {
          actionName: ACTION_NAMES.loginError,
          actionType: "Button",
          page: getPagePath(pagePath, pathname),
          currentPage: pagePath,
          error_type:
            message === OTP_ERRORS[1]
              ? ACTION_ERRORS.otpLimit
              : ACTION_ERRORS.otpGenerationFailed,
        };
        Clevertap.event(eventName, payload);
      },
    });

  const { fetchData: sendVerifyOtp, isLoading: verifyOtpLoading } = useFetch<{
    action: string;
  }>(verificationEndpoint, {
    method: REQUEST_METHODS.POST,
    init: false,
    onSuccess(currentState) {
      const { action } = currentState as { action: string };
      if (action === VerifyOTPAction.SIGNIN) {
        let popupLogin = false;
        const logInPopup = window.sessionStorage.getItem("loginPopup");
        const existingLoginPopupState =
          (logInPopup &&
            typeof logInPopup === "string" &&
            JSON.parse(logInPopup)) ||
          {};
        if (
          pagePath === "itinerary" &&
          existingLoginPopupState?.hotelIternary
        ) {
          popupLogin = true;
        } else if (
          pagePath === undefined &&
          existingLoginPopupState?.hotelHome
        ) {
          popupLogin = true;
        }
        const payload = {
          actionName: ACTION_NAMES.loginSuccess,
          actionType: "Button",
          action: "signin",
          login_banner_cookie: abLogin,
          popup: popupLogin,
          page: getPagePath(pagePath, pathname),
          currentPage: pagePath,
          login_type: "Mobile",
          first_time_login: "No",
          keep_me_logged_in: rememberCheckedStatus ? "Yes" : "No",
        };

        Clevertap.event(eventName, payload);
        handleCloseModal();
        // window.location.reload();
      }
      //TODO Need to add the signup  email linked and personal details modal,
      //for now after the signup the modal closes
      if (action === VerifyOTPAction.SIGNUP) {
        let popupLogin = false;
        const logInPopup = window.sessionStorage.getItem("loginPopup");
        const existingLoginPopupState =
          (logInPopup &&
            typeof logInPopup === "string" &&
            JSON.parse(logInPopup)) ||
          {};
        if (
          pagePath === "itinerary" &&
          existingLoginPopupState?.hotelIternary
        ) {
          popupLogin = true;
        } else if (
          pagePath === undefined &&
          existingLoginPopupState?.hotelHome
        ) {
          popupLogin = true;
        }
        const payload = {
          actionName: ACTION_NAMES.loginSuccess,
          actionType: "Button",
          action: "signup",
          login_banner_cookie: abLogin,
          popup: popupLogin,
          page: getPagePath(pagePath, pathname),
          currentPage: pagePath,
          login_type: "Mobile",
          first_time_login: "No",
          keep_me_logged_in: rememberCheckedStatus ? "Yes" : "No",
        };
        Clevertap.event(eventName, payload);
        handleCloseModal();
        window.location.reload();
      }
    },
    onError(error) {
      const { errorResponse } =
        (error as { errorResponse: { message: OTPErrorMessage } }) || {};
      const { message } = errorResponse || {};
      const errRes = errorConfig[message] || errorConfig.DEFAULT;
      const payload = {
        actionName: ACTION_NAMES.loginError,
        actionType: "Button",
        status: errRes,
        page: getPagePath(pagePath, pathname),
        currentPage: pagePath,
        error_type: ACTION_ERRORS.otpVerificationFailed,
        is_logged_in: "no",
      };
      Clevertap.event(eventName, payload);
      if (message === "INVALID_OTP") {
        setOtpValidationError(errRes);
      } else {
        setApiError(errRes);
      }
    },
  });

  const getOtpValue = () => {
    const otp = otpDigits.join("");
    return otp;
  };
  const clearOtp = () => {
    const emptyOtpDigits = ["", "", "", "", "", ""];
    setOtpDigits(emptyOtpDigits);
    refs[0]?.current?.focus();
  };
  const errorInfo = "fs-inherit c-inherit pl-2";
  const query = usePathname();

  const disabled = getOtpValue().length != 6;
  const pathname = query?.split("/");
  const pagePath = pathname?.length && pathname[2];

  const getOtp = async () => {
    setApiError("");
    const mobileValid = validateMobileHandler();
    const clevertapPayload = {
      actionName: ACTION_NAMES.otpFetched,
      login_banner_cookie: abLogin,
      actionType: "Button",
      page: getPagePath(pagePath, pathname),
      currentPage: pagePath,
    };
    Clevertap.event(eventName, clevertapPayload);
    const payload = {
      type: "MOBILE",
      value: mobile,
      countryCode: countryCode,
      action: "SIGNIN",
    };

    if (mobileValid) {
      const clevertapPayload = {
        actionName: ACTION_NAMES.mobileEntered,
        actionType: "Button",
        login_banner_cookie: abLogin,
        page: getPagePath(pagePath, pathname),
        currentPage: pagePath,
      };
      Clevertap.event(eventName, clevertapPayload);
      await sendOtpForSignIn({
        url: otpEndpoint,
        headers: {
          caller: getApiDomain(),
          "ab-otp": "b",
        },
        method: REQUEST_METHODS.POST,
        body: JSON.stringify(payload),
      });
    } else {
      const clevertapPayload = {
        actionName: ACTION_NAMES.invalidValue,
        actionType: "Button",
        page: getPagePath(pagePath, pathname),
        currentPage: pagePath,
        field_name: "mobile",
        form_name: "LoginSignUp",
      };
      Clevertap.event(eventName, clevertapPayload);
    }
  };

  const handleCloseModal = () => {
    dispatch({ type: "CLOSE_LOGIN_MODAL" });
  };
  const handleLinkClick = (url: string) => {
    const dest = `${window.location.origin}/${url}`;
    window.open(dest, "_blank");
  };
  const validateMobileHandler = () => {
    const isValid = validateMobileNumber(
      mobile,
      MOBILE_COUNTRY_CODES[countryCodeIndex].min,
      MOBILE_COUNTRY_CODES[countryCodeIndex].max
    );
    setMobileValid(isValid);
    return isValid;
  };
  useEffect(() => {
    if (mobile?.length === 10 && validateMobileHandler()) {
      getOtp();
    }

    return () => {
      clearInterval(intervalRef.current);
    };
  }, [mobile]);

  useEffect(() => {
    showOTP
      ? Clevertap.event(eventName, {
          actionName: ACTION_NAMES.loginOpened,
          actionType: "Button",
          login_banner_cookie: abLogin,
          page: getPagePath(pagePath, pathname),
          currentPage: pagePath,
        })
      : refs[0]?.current?.focus();
    // countDownHandler(30);

    if (refs[0]?.current && showOTP) {
      refs[0]?.current?.focus();
    }

    const clevertapPayload = {
      actionName: ACTION_NAMES.otpOpened,
      login_banner_cookie: abLogin,
      actionType: "Button",
      page: getPagePath(pagePath, pathname),
      currentPage: pagePath,
    };
    Clevertap.event(eventName, clevertapPayload);
  }, [showOTP]);
  const setElementInFocus = (index: number) => {
    refs[index]?.current?.focus();
  };

  const otpCursorHandler = (
    event: KeyboardEvent<HTMLInputElement>,
    index: number
  ) => {
    if (event.key === KeyEvent.ARROW_LEFT) {
      setElementInFocus(index - 1);
    }
    if (event.key === KeyEvent.ARROW_RIGHT) {
      setElementInFocus(index + 1);
    }
    if (event.key === KeyEvent.BACKSPACE) {
      if (event.currentTarget.value === "") {
        const otpFieldValues = [...otpDigits];
        const indexToRemove = index - 1;
        if (indexToRemove < 0) {
          return;
        }
        otpFieldValues[indexToRemove] = "";
        setOtpDigits(otpFieldValues);
        setElementInFocus(indexToRemove);
      } else {
        const otpFieldValues = [...otpDigits];
        otpFieldValues[index] = "";
        setOtpDigits(otpFieldValues);
      }
    }
  };
  const otpChangeHandler = (
    event: FormEvent<HTMLInputElement>,
    index: number
  ) => {
    setApiError("");
    const value = event.currentTarget.value;
    const numberValue = Number(value);
    if (value === " ") return;
    if (value === "") {
      const otpFieldValues = [...otpDigits];
      otpFieldValues[index] = "";
      setOtpDigits(otpFieldValues);
      return;
    }
    if (numberValue >= 0 && Number.isInteger(numberValue)) {
      const otpFieldValues = [...otpDigits];
      otpFieldValues[index] = (+value % 10).toString();
      setOtpDigits(otpFieldValues);
      setElementInFocus(index + 1);
      return;
    }
  };
  const verifyOtp = async () => {
    setOtpValidationError("");
    const otp = getOtpValue();
    const payload = {
      type: "MOBILE",
      value: mobile,
      countryCode: countryCode,
      action: "SIGNIN",
      otp,
    };

    const clevertapPayload = {
      actionName: ACTION_NAMES.otpEntered,
      login_banner_cookie: abLogin,
      actionType: "Button",
      page: getPagePath(pagePath, pathname),
      currentPage: pagePath,
    };
    Clevertap.event(eventName, clevertapPayload);
    await sendVerifyOtp({
      url: verificationEndpoint,
      method: REQUEST_METHODS.POST,
      body: JSON.stringify(payload),
      headers: {
        caller: getApiDomain(),
        "ab-otp": "b",
      },
    });
  };
  const resendOtp = () => {
    setApiError("");
    if (countDown !== 0 || retriesLeft <= 0) {
      return;
    } else getOtp();
  };
  useEffect(() => {
    if (otpString?.length === 4) {
      verifyOtp();
    }
  }, [otpString?.length]);

  const otpBlock = [1, 2, 3, 4].map((element, index) => {
    return (
      <OtpBox
        className={
          otpValidationError
            ? "otpError"
            : refs[index]?.current === document.activeElement
            ? "otpSelected"
            : "otpDeselected"
        }
        key={`otpBox-${index}`}
        onKeyDown={(e) => otpCursorHandler(e, index)}
        onChange={(e) => otpChangeHandler(e, index)}
        onMouseDownCapture={() => {
          setElementInFocus(index);
        }}
        ref={refs[index] as Ref<HTMLInputElement> | undefined}
        value={otpDigits[index]}
      />
    );
  });

  const countDownHandler = (countDown: number) => {
    setCountDown(countDown);
    intervalRef.current = setInterval(() => {
      setCountDown((prev) => {
        if (prev === 1) {
          clearInterval(intervalRef.current);
          setRetriesLeft((prev) => {
            if (prev === 1) return -1;
            else return prev - 1;
          });
        }
        return prev - 1;
      });
    }, 1000);
  };

  return (
    <Container className="flex">
      <Container
        height="437px"
        width="410px"
        borderRadius={"8px 0 0 8px"}
        className="o-hidden flex flex-column"
      >
        {abLogin === "a" && <BannerSlider />}
        {abLogin === "b" && (
          <img src={LOGIN_BANNER_URL} className="h-100" alt="login banner" />
        )}
      </Container>
      <Container
        borderRadius={"0 8px 8px 0"}
        className=" brLoginNew-4 o-hidden flex flex-column"
        height="437px"
        width="400px"
        style={{ background: "white" }}
      >
        {!showOTP ? (
          <Container
            className={`px-8 flex flex-1 flex-column`}
            onKeyDown={(e) => {
              if (e.key === KeyEvent.ENTER) {
                getOtp();
              }
            }}
          >
            <ModalHeader onClose={handleCloseModal} />
            {/* //TODO <OfflineToast page="proceed" /> */}
            {apiError && (
              <>
                <Container className="py-2 px-2 h-8 flex flex-middle c-neutral-100 fs-12 br-4 bg-error">
                  <InfoIcon color="#fff" height={"16"} width={"16"} />
                  <span data-testid="signinError" className={errorInfo}>
                    {apiError}
                  </span>
                </Container>
                <Container className="pt-4" />
              </>
            )}
            <Container className="flex flex-1 flex-between flex-column">
              <Container>
                {
                  <Container className="row">
                    <Container className="col-6">
                      <Container
                        className={`flex flex-middle flex-between t-all fs-12 p-relative min-w-20 ${
                          showCodeDropdown ? "bc-secondary-500" : "bc-line-500"
                        } bg-transparent c-pointer pr-2 pl-3 pt-2 pb-2 ba-solid br-4 h-9 mr-2`}
                        onClick={() =>
                          setTimeout(
                            () => setShowDropdown(!showCodeDropdown),
                            10
                          )
                        }
                      >
                        {countryCode}
                        {showCodeDropdown ? (
                          <UpChevron color="#36c" />
                        ) : (
                          <DownChevronOld color="#36c" />
                        )}
                        {showCodeDropdown && (
                          <Container
                            boxShadow={"rgb(0 0 0 / 24%) 0px 4px 12px 0px"}
                            className="bg-neutral-100 br-4 p-1 p-absolute mt-1 z-50 l-0 t-9"
                          >
                            <OutsideClickHandler
                              onOutsideClick={() => setShowDropdown(false)}
                            >
                              {MOBILE_COUNTRY_CODES.map((value, index) => {
                                return (
                                  <Container
                                    onClick={() => setCountryCodeIndex(index)}
                                    className="ls-reset br-4 px-2 bg-secondary-500 c-neutral-100 fs-14 c-pointer"
                                    key={index}
                                    width="188px"
                                    height="32px"
                                    paddingTop="6px"
                                    paddingBottom="6px"
                                  >
                                    {`${value.name} (+${value.code})`}
                                  </Container>
                                );
                              })}
                            </OutsideClickHandler>
                          </Container>
                        )}
                      </Container>
                    </Container>
                    <Container
                      className={`mobile-input__${
                        isMobileValid ? "correct" : "error"
                      } col`}
                    >
                      <input
                        className="p-2"
                        height="18px"
                        onBlur={validateMobileHandler}
                        placeholder="Enter mobile number"
                        type="number"
                        width="100%"
                        id="mobile"
                        value={mobile}
                        onChange={(e) => {
                          if (
                            e.target.value.length <=
                            MOBILE_COUNTRY_CODES[countryCodeIndex].max
                          )
                            setMobile(e.target.value);
                          setMobileValid(true);
                        }}
                      />
                      <Typography className="mt-1" variant="P3">
                        {isMobileValid
                          ? ""
                          : `Please enter a ${
                              mobile.length === 0 ? "" : "valid"
                            } phone number`}
                      </Typography>
                    </Container>
                  </Container>
                }
                <Container className="mt-6" />
                <Container>
                  <Button
                    disabled={!disabled}
                    className={`h-10 ${
                      abLogin === "a" ? "bg-black-500 hover:bg-black-500" : ""
                    }`}
                    size="medium"
                    loading={OTPloading}
                    isFullWidth
                    onClick={getOtp}
                  >
                    <span
                      className={`${!disabled ? "c-grey-30" : ""} fs-14 fw-500`}
                    >
                      {"Get OTP"}
                    </span>
                  </Button>
                </Container>
                <Container className="mt-3 fs-12 fw-400 ta-center c-light-grey">
                  {loginHelpText}
                </Container>
              </Container>
              <Container className="mb-5">
                <Container className="bc-line-500 bb" width="100%" />
                <Container className="mt-5 flex flex-column flex-middle">
                  <span>
                    <span className="fs-12 c-dark-grey">
                      By continuing, you agree to Cleartrip&#39;s
                    </span>
                    <span
                      className="fs-12 fw-500 c-pointer c-light-blue"
                      onClick={() => handleLinkClick("privacy-policy")}
                    >
                      {" "}
                      privacy policy
                    </span>{" "}
                    <span className="fs-12 c-dark-grey">&</span>{" "}
                  </span>
                  <span>
                    <span
                      className="fs-12 fw-500 c-pointer c-light-blue"
                      onClick={() => handleLinkClick("terms-of-service")}
                    >
                      terms of use.
                    </span>
                  </span>
                </Container>
              </Container>
            </Container>
          </Container>
        ) : (
          <Container
            onKeyDown={(e) => {
              if (e.key === KeyEvent.ENTER) {
                if (!disabled) {
                  verifyOtp();
                }
              }
            }}
            className={`px-8 flex flex-1 flex-column`}
          >
            <ModalHeader onClose={handleCloseModal} verifyCondition />
            {/* TODO */}
            {/* <OfflineToast page={isEmpty(email) ? 'proceed' : 'verify mobile number'} /> */}
            {apiError && (
              <>
                <Container
                  className="py-3 px-2 flex flex-middle c-neutral-100 fs-12 br-4 bg-error"
                  marginBottom="22px"
                >
                  <InfoIcon
                    className="c-neutral-100"
                    height={"16"}
                    width={"16"}
                  />
                  <span className={errorInfo}>{apiError}</span>
                </Container>
              </>
            )}
            <Container className="flex flex-column flex-between flex-1">
              <Container>
                <Container
                  className={`c-pointer flex flex-middle mt-1 ${
                    verifyOtpLoading ? "c-neutral-200" : "c-secondary-500"
                  } fs-12 fw-500`}
                >
                  <Container marginTop="2px">
                    <ArrowLeft height="18" width="18" className="c-inherit" />
                  </Container>
                  &nbsp;{" "}
                  <span
                    className="fs-2 fw-500"
                    onClick={() => {
                      setMobile("");
                      setOtpValidationError("");
                      setShowOTP(false);
                    }}
                  >
                    {"Change number"}
                  </span>
                </Container>
                <Container paddingTop="18px" />
                <p className="fs-14 c-neutral-700">
                  <span className="fs-14 c-neutral-900">
                    {" "}
                    {"Enter OTP sent to the number "}{" "}
                  </span>
                  <span className="fs-14 c-neutral-900 fw-600">{`${"+91"} ${mobile}`}</span>
                </p>
                <Container className="otpBoxInput flex">{otpBlock}</Container>
                {otpValidationError && (
                  <Container className="c-error-500 mb-3">
                    {otpValidationError}
                  </Container>
                )}
                <Container className="mb-7">
                  <span className="fs-12 c-neutral-900">
                    {"Haven't received OTP?"}
                  </span>
                  <span
                    onClick={resendOtp}
                    className={`fs-12 fw-500 ml-1 ${
                      retriesLeft === -1
                        ? "c-neutral-200"
                        : countDown !== 0
                        ? `c-neutral-200`
                        : OTPloading
                        ? "c-neutral-200"
                        : "c-blue c-pointer"
                    }`}
                  >
                    {retriesLeft === -1
                      ? "Resend"
                      : countDown !== 0
                      ? `Resend (${countDown}s)`
                      : "Resend"}
                  </span>
                </Container>
                {
                  <Container className="checkbox flex h-5">
                    <Checkbox
                      checked={rememberCheckedStatus}
                      onClick={() =>
                        setRememberCheckedStatus(!rememberCheckedStatus)
                      }
                    />
                    <Container className="flex flex-middle pl-2 c-neutral-900 fs-12 h-5">
                      {"Keep me logged in"}
                    </Container>
                  </Container>
                }
              </Container>
            </Container>
          </Container>
        )}
      </Container>
    </Container>
  );
};
export default LoginWithMobile;
